import React from 'react';

export type UseCountDownState = {
  days: string;
  rawDays: number;
  totalHours: string;
  hours: string;
  rawHours: number;
  minutes: string;
  seconds: string;
  hasStarted: boolean;
  finished: boolean;
};

const useCountdown = (expireDate?: Date, skip?: boolean): UseCountDownState => {
  const refInterval = React.useRef<number>(0);
  const [days, setDays] = React.useState<{ value: string; raw: number }>({
    value: '99',
    raw: 99,
  });
  const [hours, setHours] = React.useState<string>('99');
  const [rawHours, setRawHours] = React.useState<number>(0);
  const [totalHours, setTotalHours] = React.useState<string>('99');
  const [minutes, setMinutes] = React.useState<string>('00');
  const [seconds, setSeconds] = React.useState<string>('00');
  const [finished, setFinished] = React.useState(
    expireDate ? expireDate.getTime() <= new Date().getTime() : true,
  );

  const updateCountdown = () => {
    const nowDate = new Date().getTime();
    const timeLeftinMilisecs = expireDate!.getTime() - nowDate;

    const rawDaysLef = Math.floor(timeLeftinMilisecs / (1000 * 60 * 60 * 24));
    const daysLeft = `0${rawDaysLef}`.slice(-2);

    const totalHrs = Math.floor(timeLeftinMilisecs / (1000 * 60 * 60));

    const rawHoursLeft = totalHrs > 23 ? totalHrs % 24 : totalHrs;
    const hoursLeft = `0${(totalHrs > 23
      ? totalHrs % 24
      : totalHrs
    ).toString()}`.slice(-2);

    const minutesLeft = `0${Math.floor(
      (timeLeftinMilisecs % (1000 * 60 * 60)) / (1000 * 60),
    ).toString()}`.slice(-2);

    const secondsLeft = `0${Math.floor(
      (timeLeftinMilisecs % (1000 * 60)) / 1000,
    ).toString()}`.slice(-2);

    setDays({
      value: daysLeft,
      raw: rawDaysLef,
    });
    setTotalHours(
      totalHrs.toString().length < 2
        ? `0${totalHrs.toString()}`
        : totalHrs.toString(),
    );
    setHours(hoursLeft);
    setRawHours(rawHoursLeft);
    setMinutes(minutesLeft);
    setSeconds(secondsLeft);

    if (timeLeftinMilisecs <= 0) {
      clearInterval(refInterval.current);
      setFinished(true);
    }
  };

  React.useEffect(() => {
    if (expireDate && !finished) {
      if (!skip) {
        refInterval.current = setInterval(() => {
          updateCountdown();
        }, 1000);
      }
      updateCountdown();
    }
    return () => clearInterval(refInterval.current);
  }, [skip]);

  return {
    days: days.value,
    rawDays: days.raw,
    totalHours,
    rawHours,
    hours,
    minutes,
    seconds,
    hasStarted: hours !== '99',
    finished,
  };
};

export default useCountdown;
